import TmdbImage from "../../../shared/tmdb-image/tmdb-image";
import React from "react";

import './item-backdrop-details.scss';
import {cn} from "../../../../utils/utils";
import CachedImage from "../../../shared/cached-image/cached-image";

type Props = {
    overlay?: {
        bottomLeft?: React.ReactNode;
        bottomRight?: React.ReactNode;
        topLeft?: React.ReactNode;
        topRight?: React.ReactNode;
        center?: React.ReactNode;
    }
    onClickPoster?: () => void;
    detailsTitle?: React.ReactNode;
    detailsSubtitle?: React.ReactNode;
    detailsInfo?: React.ReactNode;
    onClickDetails?: () => void;
    tmdbSrc?: string;
    cachedSrc?: string;
    isSpoiler?: boolean;
    className?: string;
    style?: React.CSSProperties;
    size?: "w200" | "w300" | "w500" | "original";
    aspectRatio?: string;
    hideOptionsIcon?: boolean;
}

const ItemBackdropDetails = (props: Props) => {

    const {
        overlay,
        onClickPoster,
        detailsTitle,
        detailsSubtitle,
        detailsInfo,
        onClickDetails,
        tmdbSrc,
        cachedSrc,
        isSpoiler,
        className,
        style,
        size: imageSize = "w500",
        aspectRatio = "16/9",
        hideOptionsIcon = false
    } = props;

    return (
        <div className={cn("item-poster-details", className)} style={style}>
            <button className="item-poster-details-still" onClick={onClickPoster} style={{
                aspectRatio: aspectRatio ?? "16/9"
            }}>
                {tmdbSrc && <TmdbImage isSpoiler={isSpoiler} src={tmdbSrc} size={imageSize ?? "w500"} style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center"
                }}/>}
                {!tmdbSrc && cachedSrc && <CachedImage isSpoiler={isSpoiler} src={cachedSrc} style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center"
                }}/>}
                <div className="item-poster-details-still-overlay">
                    {!!overlay?.bottomRight &&
                        <span className="item-poster-details-still-overlay-bottomRight">
                            {overlay.bottomRight}
                        </span>
                    }
                    {!!overlay?.bottomLeft &&
                        <span className="item-poster-details-still-overlay-bottomLeft">
                            {overlay.bottomLeft}
                        </span>
                    }
                    {!!overlay?.topRight &&
                        <span className="item-poster-details-still-overlay-topRight">
                            {overlay.topRight}
                        </span>
                    }
                    {!!overlay?.topLeft &&
                        <span className="item-poster-details-still-overlay-topLeft">
                            {overlay.topLeft}
                        </span>
                    }
                    {!!overlay?.center &&
                        <span className="item-poster-details-still-overlay-center">
                            {overlay.center}
                        </span>
                    }
                </div>
            </button>
            {(detailsInfo || detailsTitle || detailsSubtitle) &&
                <button className="item-poster-details-details" onClick={onClickDetails}>
                    <div>
                        {detailsInfo && <div className="item-poster-details-info text-muted mb-1">
                            {detailsInfo}
                        </div>}
                        {detailsTitle && <div className="item-poster-details-title">
                            {detailsTitle}
                        </div>}
                        {detailsSubtitle && <div className="item-poster-details-info text-muted">
                            {detailsSubtitle}
                        </div>}
                    </div>
                    <div hidden={hideOptionsIcon}>
                        <i className="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                </button>}
        </div>
    );
};

export default ItemBackdropDetails;
